import { render } from "./firmRegister.vue?vue&type=template&id=3a25c104&scoped=true"
import script from "./firmRegister.vue?vue&type=script&lang=js"
export * from "./firmRegister.vue?vue&type=script&lang=js"

import "./firmRegister.vue?vue&type=style&index=0&id=3a25c104&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a25c104"]])

export default __exports__